export default __webpack_public_path__ + "3940ac60bb738b4996649c7b5a71ab34.png";